import { createSelector } from 'reselect';

import * as _ from 'lodash';

const getSecAllList = (state) => state.market.secListAll;
const getNNInday = (state) => state.market.analNNInday;
const getAnalPBDongTien = (state) => state.market.analPBDongTien;
const getAnalFSRatio = (state) => {
  const {analFSRatio} = state.market;
  if(!analFSRatio) return null;
  return _.sortBy(analFSRatio, 'ROW_ORDER').reverse();
};
const getAnalRankFSRatio = (state) => state.market.analRankFSRatio;
const getAnalSecOverview = (state) => state.market.analSecOverview;

const getAnalComIntroduction = (state) => {
  const {analComIntroduction} = state.market;
  if(!analComIntroduction?.profile) return null;

  const lang = state.client.setting?.lang || 'vi';
  
  var div = document.createElement("div");
  div.innerHTML = lang === 'vi' ? analComIntroduction?.profile : analComIntroduction?.profileEn;

  return div.innerText;
}
const getAnalComBasic = (state) => state.market.analComBasic;
const getAnalComSameInd = (state) => state.market.analComSameInd;
const getAnalComLeader = (state) => state.market.analComLeader;
const getAnalComHolder = (state) => state.market.analComHolder;
const getAnalComEvents = (state) => state.market.analComEvents;
const getAnalComBigTrans = (state) => state.market.analComBigTrans;
const getAnalComRelated = (state) => state.market.analComRelated;

const getAnalIndexReal = (state) => state.market.analIndReal;
const getAnalStockReal = (state) => state.market.analStReal;
const getAnalLichSuGia = (state) => {
  const {analLichSuGia} = state.market;

  if(analLichSuGia) return analLichSuGia.reverse();

  return null;
};
const getAnalSTMatchPrice = (state) => state.market.analStMatchPrice;
const getAnalSTMBActive = (state) => state.market.analStMBActive;
const getAnalBasicInfo = (state) => state.market.analBasicInfo;

const getAnalFilterRange = (state) => state.market.analFilterRange;
const getAnalFilterAct = (state) => state.market.analFilterAct;
const getAnalUserFilter = (state) => state.market.analUserFilter;

const getAnalUserSignal = (state) => {
  const {analUserSignal} = state.market;
  return _.filter(analUserSignal?.signals, o => o.active === true);
}
/************************************** MAKE GET ****************************************/

export const makeGetSecAllList = () =>
  createSelector([getSecAllList], (secListAll) => secListAll);

export const makeGetAnalIndexReal = () =>
  createSelector([getAnalIndexReal], (analIndReal) => analIndReal);

export const makeGetAnalStockReal = () =>
  createSelector([getAnalStockReal], (analStReal) => analStReal);

export const makeGetAnalSTMatchPrice = () =>
  createSelector([getAnalSTMatchPrice], (analStMatchPrice) => analStMatchPrice);

export const makeGetAnalSTMBActive = () =>
  createSelector([getAnalSTMBActive], (analStMBActive) => analStMBActive);

export const makeGetNNInday = () =>
  createSelector([getNNInday], (analNNInday) => analNNInday);

export const makeGetAnalPBDongTien = () =>
  createSelector([getAnalPBDongTien], (analPBDongTien) => analPBDongTien);

export const makeGetAnalLichSuGia = () =>
  createSelector([getAnalLichSuGia], (analLichSuGia) => analLichSuGia);

export const makeGetAnalBasicInfo = () =>
  createSelector([getAnalBasicInfo], (analBasicInfo) => analBasicInfo);

export const makeGetAnalFSRatio = () =>
  createSelector([getAnalFSRatio], (analFSRatio) => analFSRatio);

export const makeGetAnalRankFSRatio = () =>
  createSelector([getAnalRankFSRatio], (analRankFSRatio) => analRankFSRatio);

export const makeGetAnalSecOverview = () =>
  createSelector([getAnalSecOverview], (analSecOverview) => analSecOverview);

export const makeGetAnalComIntroduction = () =>
  createSelector([getAnalComIntroduction], (analComIntroduction) => analComIntroduction);

export const makeGetAnalComBasic = () =>
  createSelector([getAnalComBasic], (analComBasic) => analComBasic);

export const makeGetAnalComSameInd = () =>
  createSelector([getAnalComSameInd], (analComSameInd) => analComSameInd);

export const makeGetAnalComLeader = () =>
  createSelector([getAnalComLeader], (analComLeader) => analComLeader);

export const makeGetAnalComHolder = () =>
  createSelector([getAnalComHolder], (analComHolder) => analComHolder);

export const makeGetAnalComEvents = () =>
  createSelector([getAnalComEvents], (analComEvents) => analComEvents);

export const makeGetAnalComBigTrans = () =>
  createSelector([getAnalComBigTrans], (analComBigTrans) => analComBigTrans);

export const makeGetAnalComRelated = () =>
  createSelector([getAnalComRelated], (analComRelated) => analComRelated);

export const makeGetAnalFilterRange = () =>
  createSelector([getAnalFilterRange], (analFilterRange) => analFilterRange);

export const makeGetAnalFilterAct = () =>
  createSelector([getAnalFilterAct], (analFilterAct) => analFilterAct);

export const makeGetAnalUserFilter = () =>
  createSelector([getAnalUserFilter], (analUserFilter) => analUserFilter);

export const makeGetAnalUserSignal = () =>
  createSelector([getAnalUserSignal], (analUserSignal) => analUserSignal);

